function sylevaToggleGreeting(radio) {
  if (!radio) return;

  var suffix = radio.name.replace('product-grusskarte-', '');
  var formId = 'product-form-' + suffix;

  var textarea = document.querySelector('textarea[form="' + formId + '"], input[form="' + formId + '"]');
  if (!textarea) return;

  var wrapper = textarea.closest('[data-js-custom-property]');
  if (!wrapper) return;

  var showField = radio.value.toLowerCase().indexOf('ohne') === -1;
  if (showField) {
    wrapper.classList.add('greeting-visible');
  } else {
    wrapper.classList.remove('greeting-visible');
  }
}

document.addEventListener('change', function(e) {
  var target = e.target;
  if (!target || target.type !== 'radio') return;
  if (target.name.toLowerCase().indexOf('grusskarte') === -1) return;
  sylevaToggleGreeting(target);
});

function sylevaInitGreeting() {
  var checkedRadios = document.querySelectorAll('input[type="radio"][name*="grusskarte"]:checked');
  checkedRadios.forEach(function(radio) {
    sylevaToggleGreeting(radio);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sylevaInitGreeting);
} else {
  sylevaInitGreeting();
}